import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import store from "./store";
import { App as AppWrapper, ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ErrorFallbackPage, SiteLoader, alias } from "./helpers/utils";
import { ErrorBoundary } from "react-error-boundary";

// ToastHandler
import ToastHandler from "./helpers/ToastHandler";

// Translation
import "./helpers/i18n";

// CSS
import "./Assets/CSS/custom.css";
import "./Assets/CSS/style.css";
import "./Assets/CSS/component.css";

// Auth CSS
import "./Auth/CSS/style.css";

// Component CSS
import "./Components/CSS/style.css";

// Admin CSS
import "./Admin/CSS/style.css";
import "./Admin/CSS/admin.css";

// View CSS
import "./View/CSS/style.css";

// Swiper Js
import "swiper/css";
import "swiper/css/navigation";
import { sideMenuBarData } from "./Assets/navigation";
import Crypto from "./Admin/Pages/Crypto";


// import { Dashboard } from "./Admin/Pages/Dashboard";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Auth Pages
const AuthIndex = lazy(() => import("./Auth/AuthIndex"));
const Login = lazy(() => import("./Auth/Pages/Login"));
const ForgotPassword = lazy(() => import("./Auth/Pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./Auth/Pages/ResetPassword"));
// admin pages
const Dashboard = lazy(() => import("./Admin/Pages/Dashboard"));
const Dashboard2 = lazy(() => import("./Admin/Pages/Dashboard2"));
const Clubs = lazy(() => import("./Admin/Pages/Clubs"));
const Athletes = lazy(() => import("./Admin/Pages/Athletes"));
const Customers = lazy(() => import("./Admin/Pages/Customer"));
const Products = lazy(() => import("./Admin/Pages/Products"));
const NhsProducts = lazy(() => import("./Admin/Pages/NhsProducts"));

const NotFoundProducts = lazy(() => import("./Admin/Pages/NotFoundProduct"));
const Reports = lazy(() => import("./Admin/Pages/Reports"));
const ReportsByAthletes = lazy(() => import("./Admin/Pages/ReportsByAthletes"));

const SupportRequest = lazy(() => import("./Admin/Pages/SupportRequest"));
const QueryRaised = lazy(() => import("./Admin/Pages/QueryRaised"));


const EmailNotification = lazy(() => import("./Admin/Pages/EmailNotification"));
const Subscription = lazy(() => import("./Admin/Pages/Subscription"));
const BannedIngredients = lazy(() => import("./Admin/Pages/BannedIngredients"));
const StaticData = lazy(() => import("./Admin/Pages/StaticData"));
const DataSync = lazy(() => import("./Admin/Pages/DataSync"));
const Bills = lazy(() => import("./Admin/Pages/Bill"));
const Setting = lazy(() => import("./Admin/Pages/Setting"));
const SubAdmin = lazy(() => import("./Admin/Pages/SubAdmin"));
//profile and change password
const Profile = lazy(() => import("./Admin/Pages/Profile"));
const ChangePassword = lazy(() => import("./Admin/Pages/ChangePassword"));
//email template
const EmailTemplate = lazy(() => import("./Admin/Pages/EmailTemplate"));
const EditEmailTemplate = lazy(() => import("./Admin/Pages/EditEmailTemplate"));
//static pages
const StaticPages = lazy(() => import("./Admin/Pages/StaticPages"));
const EditStaticPage = lazy(() => import("./Admin/Pages/EditStaticPage"));
const Privacy = lazy(() => import("./Admin/Views/Privacy"));
const Terms = lazy(() => import("./Admin/Views/TermsAndConditions"));
const DataDeletion = lazy(() => import("./Admin/Views/DataDeletion"));
const CommonStaticPages = lazy(() => import("./Admin/Views/Common"));
const SubscriptionPayment = lazy(() => import("./Admin/Pages/SubscriptionPayment"));
//AI Prompt
const AiPrompt = lazy(() => import("./Admin/Pages/AiPrompt"));
const Outcomes = lazy(() => import("./Admin/Pages/Outcomes"));
const Substance = lazy(() => import("./Admin/Pages/substance/Substance"));
// Comman Pages

// Learner Pages
const ViewIndex = lazy(() => import("./View/ViewIndex"));
const Home = lazy(() => import("./Admin/Pages/Home"));

// Parent Pages
const AdminIndex = lazy(() => import("./Admin/AdminIndex"));

/** Error Page */
const PageNotFound = lazy(() => import("./Components/Pages/Error"));

// CSSIndex2
const CSSINDEX2 = lazy(() => import("./View/CSSIndex2"));

root.render(
    <React.StrictMode>
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: "Nunito Sans Regular",
                },
            }}
        >
            <AppWrapper>
                <Provider store={store}>
                    {/* live */}
                    {/* <BrowserRouter> */}
                    {/* dev */}
                    <BrowserRouter basename={alias}>
                        <Suspense fallback={<SiteLoader />}>
                            <ErrorBoundary FallbackComponent={ErrorFallbackPage}>
                                {/* Route List */}
                                <Routes>
                                    {/* Auth */}
                                    <Route path="/auth" element={<AuthIndex />}>
                                        <Route path="login" element={<Login />} />
                                        {/* <Route path="sign-up" element={<SignUp />} /> */}
                                        {/* <Route path="sign-up/:role" element={<SignUp />} /> */}
                                        <Route path="forgot-password" element={<ForgotPassword />} />
                                        <Route path="forgot-password/:token" element={<ResetPassword />} />
                                    </Route>
                                    {/* Auth */}

                                    {/* View */}
                                    <Route path="/" element={<ViewIndex roleName={""} />}>
                                        {/* <Route exact path="" element={<Home />} /> */}
                                        {/* <Route exact path="" element={<Login />} /> */}
                                        <Route exact path="" element={<Navigate to="/admin" replace />} />
                                        <Route path="*" element={<PageNotFound />} />
                                    </Route>
                                    {/* View */}

                                    {/* Admin */}
                                    <Route path="/admin" element={<AdminIndex roleName={["admin", "sub-admin"]} navigationData={sideMenuBarData} />}>
                                        <Route exact path="" element={<Dashboard />} />
                                        <Route path="dashboard" element={<Dashboard />} />
                                        <Route path="test-error-page" element={<Dashboard2 />} />
                                        <Route path="clubs" element={<Clubs />} />
                                        <Route path="athletes" element={<Athletes />} />
                                        <Route path="customers" element={<Customers />} />
                                        <Route path="products" element={<Products />} />
                                        <Route path="nhs-products" element={<NhsProducts />} />
                                        <Route path="not-found-products" element={<NotFoundProducts />} />
                                        <Route path="reports" element={<Reports />} />
                                        <Route path="reports-by-athletes" element={<ReportsByAthletes />} />

                                        <Route path="support-requests" element={<SupportRequest />} />
                                        <Route path="ai-prompt" element={<AiPrompt />} />
                                        <Route path="outcomes" element={<Outcomes />} />
                                        <Route path="substance" element={<Substance />} />
                                        <Route path="query-raised" element={<QueryRaised />} />

                                        <Route path="email-and-notifications" element={<EmailNotification />} />
                                        <Route path="subscriptions" element={<Subscription />} />

                                        <Route path="banned-ingredients" element={<BannedIngredients />} />
                                        <Route path="static-data" element={<StaticData />} />
                                        <Route path="sync-data" element={<DataSync />} />
                                        <Route path="bill-management" element={<Bills />} />
                                        <Route path="settings" element={<Setting />} />
                                        <Route path="sub-admin" element={<SubAdmin />} />

                                        <Route path="profile" element={<Profile />} />
                                        <Route path="change-password" element={<ChangePassword />} />

                                        <Route path="*" element={<PageNotFound />} />

                                        <Route path="static-pages">
                                            <Route path="" element={<StaticPages />} />
                                            <Route exact path="edit-staticpage/:id" element={<EditStaticPage />} />
                                        </Route>
                                        {/* email template */}
                                        <Route path="email-template">
                                            <Route path="" element={<EmailTemplate />} />
                                            <Route exact path="edit/:id" element={<EditEmailTemplate />} />
                                        </Route>
                                        {/* email template */}


                                    </Route>
                                    {/* Admin */}

                                    {/* static pages */}
                                    <Route path="/" element={<CSSINDEX2 />}>
                                        <Route path="privacy-policy" element={<Privacy />} />
                                        <Route path="terms-and-conditions" element={<Terms />} />
                                        <Route path="data-deletion-content" element={<DataDeletion />} />
                                        {/* <Route path="about-us" element={<AboutUs />} /> */}
                                        {/* <Route path="contact-us" element={<ContactUs />} /> */}
                                        <Route path="static-page/:url" element={<CommonStaticPages />} />

                                        <Route path="subscription-payment/:id" element={<SubscriptionPayment />} />
                                    </Route>

                                    {/* static pages */}

                                    {/* Crypto */}
                                    <Route path="crypto">
                                        <Route path="" element={<Crypto />} />
                                    </Route>
                                    {/* Crypto */}


                                    <Route path="*" element={<PageNotFound />} />




                                    {/* Comman */}
                                </Routes>
                                {/* Route List End */}
                            </ErrorBoundary>
                        </Suspense>
                    </BrowserRouter>
                    <ToastHandler />
                </Provider>
            </AppWrapper>
        </ConfigProvider>
    </React.StrictMode>
);
